// @ts-check

// The iOS app's App Store subscriptions (StoreKit product IDs), one
// subscription group in App Store Connect, mirroring the website's current
// Stripe plans (subscriptionPlans.js). Entitlement comes from product identity,
// as from Stripe Price identity; unknown products are refused, never guessed.

/**
 * @typedef {{
 *   productID: string,
 *   permissions: "standard" | "plus",
 *   months: 1 | 12,
 * }} AppStoreProduct
 */

/** In the order the app offers them @type {AppStoreProduct[]} */
export const products = [
  {
    productID: "com.readlang.app.premium.monthly",
    permissions: "standard",
    months: 1,
  },
  {
    productID: "com.readlang.app.premium.yearly",
    permissions: "standard",
    months: 12,
  },
  {
    productID: "com.readlang.app.premiumplus.monthly",
    permissions: "plus",
    months: 1,
  },
  {
    productID: "com.readlang.app.premiumplus.yearly",
    permissions: "plus",
    months: 12,
  },
];

/**
 * @param {string | undefined} productID
 * @returns {AppStoreProduct | undefined}
 */
export const productFromID = (productID) =>
  products.find((product) => product.productID === productID);
